import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Definition = ({
    term,
    isTermLabel = true,
    forceShow = false,
    perfectCenter = false,
    description,
    children,
    className,
}) => (
    description || children || forceShow ? (
        <div
            className={
                classNames('pp-definition', className) +
                (perfectCenter ? ' pp-definition__perfect-center' : '')
            }
        >
            {
                term &&
                <dt className="pp-definition__term">
                    {isTermLabel ? `${term}:` : term}
                </dt>
            }
            <dd className="pp-definition__description">
                {children || description}
            </dd>
        </div>
    ) : null
);

Definition.propTypes = {
    term: PropTypes.string.isRequired,
    isTermLabel: PropTypes.bool,
    forceShow: PropTypes.bool,
    perfectCenter: PropTypes.bool,
    description: PropTypes.oneOfType(
        [PropTypes.string, PropTypes.number]
    ),
    className: PropTypes.string,
    children: PropTypes.node,
};

export default Definition;



// WEBPACK FOOTER //
// ./src/js/shared/Definition.jsx